import type { QuoteState } from '../../vendor-dashboard/types/quote';
import { ACTION_TYPES } from '../../vendor-dashboard/constants';

const DEFAULT_STATE: QuoteState = {
    quotes: [],
    quote: null,
    headers: {},
    parents: [],
    loading: false,
};

const reducer = ( state = DEFAULT_STATE, action ): QuoteState => {
    switch ( action.type ) {
        case ACTION_TYPES.SET_QUOTES:
            return {
                ...state,
                quotes: [ ...action.quotes ],
            };

        case ACTION_TYPES.SET_QUOTE:
            return {
                ...state,
                quote: action.quote,
                quotes: state.quotes.map( ( q ) =>
                    q.id === action.quote.id ? action.quote : q
                ),
            };

        case ACTION_TYPES.SET_HEADERS:
            return {
                ...state,
                headers: action.headers,
            };

        case ACTION_TYPES.SET_LOADING:
            return {
                ...state,
                loading: action.loading,
            };

        case ACTION_TYPES.SET_PARENT_QUOTES:
            return {
                ...state,
                parents: [ ...action.parents ],
            };

        case ACTION_TYPES.REMOVE_QUOTE:
            return {
                ...state,
                quotes: [
                    ...state.quotes.filter( ( q ) => q.id !== action.quoteId ),
                ],
                parents: [
                    ...state.parents.filter( ( p ) => p.id !== action.quoteId ),
                ],
            };

        default:
            return state;
    }
};

export default reducer;
